import { graphic } from 'echarts/core';
import { Circle } from 'echarts/types/src/util/graphic';
import { CircleProps, ZRenderType } from 'zrender';

export class BreathCircle {
  shadow: Circle;

  circle: Circle;

  chart: any;

  options: any;

  isBreath: boolean;

  breathTimer: any;
  zr: ZRenderType;

  constructor(zr, chart, options) {
    this.chart = chart;
    this.options = options;
    this.circle = null;
    this.shadow = null;
    this.isBreath = false;
    this.breathTimer = null;
    this.zr = zr;

    this.init(zr, chart, options);
  }

  init(zr, chart, options) {
    this.draw(options);
  }

  draw(options) {
    const { r, style, z } = options;
    const circle = new graphic.Circle({
      ignoreClip: true,
      shape: {
        cx: 0,
        cy: 0,
        r
      },
      style,
      z
    });
    const shadow = new graphic.Circle({
      ignoreClip: true,
      shape: {
        cx: 0,
        cy: 0,
        r
      },
      style,
      z: z - 1
    });
    this.shadow = shadow;
    this.circle = circle;
  }

  cubicOut(k) {
    return --k * k * k + 1;
  }

  breath(isBreath) {
    if (isBreath === this.isBreath) {
      return;
    }
    this.isBreath = isBreath;
    if (isBreath) {
      this.shadow
        .animate('shape', true)
        .when(
          400,
          {
            r: this.circle.shape.r * 2
          },
          'cubicOut'
        )
        .when(
          800,
          {
            r: this.circle.shape.r
          },
          'cubicOut'
        )
        .start();
      this.shadow
        .animate('style', true)
        .when(
          400,
          {
            opacity: 0.25
          },
          'cubicOut'
        )
        .when(
          800,
          {
            opacity: 0.25
          },
          'cubicOut'
        )
        .start();
    }
  }

  move(position) {
    const [x, y] = position;
    this.circle.attr({
      shape: {
        cx: x,
        cy: y
      }
    });
    this.shadow.attr({
      shape: {
        cx: x,
        cy: y
      }
    });
  }

  attr(property: CircleProps) {
    if (this.zr.animation !== null) {
      this.circle.attr(property);
      this.shadow.attr(property);
    }
  }

  remove() {
    if (this.zr.animation !== null) {
      this.shadow.attr('ignore', true);
      this.zr.remove(this.shadow);
      this.circle.attr('ignore', true);
      this.zr.remove(this.circle);
    }
  }
}
